import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import EnrollmentCompletedIcon from "../../../assets/images/svg/enrollment_completed.svg";
import { Button } from "cxa-components";
import { withRouter } from "react-router";
import messages from "components/messagesDescription";
import { loadNewNavMenus } from "actions/commonActions";
import { getDashboardActions } from "actions/dashboardActionsPP";

const EnrollmentSuccess = ({ intl, push, ...rest }) => {
  const dispatch = useDispatch();
  const goToBenefitsStatement = () => {
    push("/benefits/statement");
  };

  useEffect(() => {
    dispatch(loadNewNavMenus());
    dispatch(getDashboardActions());
  }, []);
  return (
    <div>
      <div>
        <div style={{ width: "200px", marginLeft: "auto", marginRight: "auto" }}>
          <EnrollmentCompletedIcon style={{ width: "200px" }} />
        </div>
      </div>

      <div style={{ textAlign: "center" }}>
        <h4>{intl.formatMessage(messages.enrollment.checkOutSuccessDescription)}</h4>

        <p>{intl.formatMessage(messages.enrollment.viewBenefitsStatementDescription)}</p>
        <Button primary type="button" className="enrolment-btn" onClick={goToBenefitsStatement}>
          {intl.formatMessage(messages.enrollment.viewCoverageDescription)}
        </Button>
      </div>
    </div>
  );
};

EnrollmentSuccess.propTypes = {
  push: PropTypes.func.isRequired,
  intl: PropTypes.func.isRequired,
};

export default withRouter(injectIntl(EnrollmentSuccess));



// WEBPACK FOOTER //
// ./components/employee/shop/EnrollmentSuccess.js